import React from 'react';

import Icon from 'Components/Icon';

export default [
  [
    {
      id: 'invoices',
      text: 'Invoices',
      icon: <Icon name="icon-invoice" />,
      path: '/customer/invoices',
    },
    {
      id: 'orders',
      text: 'Orders',
      icon: <Icon name="icon-payment" />,
      path: '/customer/orders',
    },
    {
      id: 'team',
      text: 'Team',
      icon: <Icon name="icon-team" />,
      path: '/customer/team',
    },
  ],
  [
    {
      id: 'mobile-builds',
      text: 'Mobile Builds',
      icon: <Icon name="icon-mobile" />,
      path: '/customer/mobile-builds/',
    },
  ],
];
